module.exports = __webpack_public_path__ + "static/img/ny-07-CONTACT.c5a7a896.jpg";